export default function ImagePlaceholder({ label, height = 220, borderRadius = '12px', style = {} }) {
  return (
    <div
      style={{
        width: '100%',
        height: `${height}px`,
        background: '#C0392B',
        border: '2px dashed #E67E22',
        borderRadius,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        ...style,
      }}
      aria-label={label}
      role="img"
    >
      <p style={{
        fontFamily: 'Inter, sans-serif',
        fontSize: '13px',
        fontWeight: 600,
        color: '#FFFFFF',
        textAlign: 'center',
        lineHeight: 1.5,
        opacity: 0.9,
        letterSpacing: '0.02em',
      }}>
        {label}
      </p>
    </div>
  );
}
